// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2":"5f096bb9","3":"473bf0f2","998":"4abc09fb"}[chunkId] + ".css";
};